<template>
  <b-modal v-model="show" :title="titulo" size="lg" hide-footer scrollable>
    <div v-if="resultado">
      <b-row class="mb-1">
        <b-col md="4">
          <small class="text-muted">Status</small><br>
          <b-badge :variant="resultado.status === 'SUCESSO' ? 'light-success' : 'light-danger'" class="font-medium-1">
            {{ resultado.status }}
          </b-badge>
        </b-col>
        <b-col md="4">
          <small class="text-muted">HTTP</small><br>
          <strong>{{ resultado.status_http || '—' }}</strong>
        </b-col>
        <b-col md="4">
          <small class="text-muted">Tempo</small><br>
          <strong>{{ resultado.tempo_ms }} ms</strong>
        </b-col>
      </b-row>

      <div v-if="resultado.error" class="mb-1">
        <small class="text-muted">Erro</small>
        <pre class="result-block result-block-error">{{ resultado.error }}</pre>
      </div>

      <div>
        <small class="text-muted">Resposta (staging cru)</small>
        <pre class="result-block">{{ responseFormatted }}</pre>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-1">
      <b-button variant="primary" @click="show = false">Fechar</b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ResultadoExecucaoModal',
  data() {
    return { show: false, job: null, resultado: null };
  },
  computed: {
    titulo() {
      return this.job ? `Execução: ${this.job.nome}` : 'Resultado da execução';
    },
    responseFormatted() {
      if (!this.resultado) return '';
      const r = this.resultado.response;
      if (r === null || r === undefined || r === '') return '(sem corpo)';
      if (typeof r === 'string') {
        try { return JSON.stringify(JSON.parse(r), null, 2); } catch (e) { return r; }
      }
      return JSON.stringify(r, null, 2);
    },
  },
  methods: {
    open(job, resultado) {
      this.job = job;
      this.resultado = resultado;
      this.show = true;
    },
  },
};
</script>

<style scoped>
.result-block {
  background: #f8f8f8;
  padding: 10px;
  border-radius: 4px;
  max-height: 360px;
  overflow: auto;
  font-size: 12px;
  white-space: pre-wrap;
}
.result-block-error { background: #fff3f3; color: #b00020; }
</style>
